import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api";
import { useAuth } from "../AuthContext";
import { FileText, Layers, BookOpen, Image as ImageIcon, Settings, ArrowRight } from "lucide-react";

const DashboardPage = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState({ pages: 0, blocks: 0, stories: 0, media: 0 });

  useEffect(() => {
    const load = async () => {
      try {
        const [pages, stories, media] = await Promise.all([
          apiClient.get("/admin/pages"),
          apiClient.get("/admin/stories"),
          apiClient.get("/admin/media"),
        ]);
        setStats({
          pages: pages.data.length,
          blocks: 0, // computed below per-page if needed
          stories: stories.data.length,
          media: media.data.length,
        });
      } catch {
        /* ignore */
      }
    };
    load();
  }, []);

  const cards = [
    { to: "/admin/pages", label: "Pagina's", icon: FileText, count: stats.pages, hint: "Beheer hero, intro en SEO per pagina" },
    { to: "/admin/blocks", label: "Contentblokken", icon: Layers, count: null, hint: "Bouw flexibele paginainhoud" },
    { to: "/admin/stories", label: "Verhalen", icon: BookOpen, count: stats.stories, hint: "Editorial content, redactioneel" },
    { to: "/admin/media", label: "Media", icon: ImageIcon, count: stats.media, hint: "Uploads, alt-teksten, hergebruik" },
    { to: "/admin/settings", label: "Instellingen", icon: Settings, count: null, hint: "Bedrijfsgegevens, footer, CTA" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-12">
        <p className="text-[11px] tracking-[0.3em] uppercase text-champagne font-body mb-3">
          Dashboard
        </p>
        <h1 className="font-display text-5xl text-white tracking-tight">
          Welkom terug{user?.name ? `, ${user.name}` : ""}.
        </h1>
        <p className="mt-4 text-base text-zinc-400 font-body max-w-xl">
          Hier kunt u de inhoud van de website beheren — teksten, foto's,
          verhalen, contactgegevens en meer.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {cards.map(({ to, label, icon: Icon, count, hint }) => (
          <Link
            key={to}
            to={to}
            data-testid={`dashboard-card-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            className="group bg-ink-900 border border-white/[0.06] p-7 hover:border-champagne/30 transition-colors"
          >
            <div className="flex items-start justify-between mb-6">
              <div className="w-11 h-11 border border-white/10 flex items-center justify-center text-champagne group-hover:border-champagne/40 transition-colors">
                <Icon size={18} />
              </div>
              {count !== null && (
                <span className="font-display text-3xl text-white">
                  {String(count).padStart(2, "0")}
                </span>
              )}
            </div>
            <h2 className="font-display text-2xl text-white tracking-tight mb-2">
              {label}
            </h2>
            <p className="text-sm text-zinc-500 font-body mb-6 leading-relaxed">
              {hint}
            </p>
            <div className="flex items-center gap-2 text-[11px] tracking-[0.25em] uppercase text-champagne group-hover:gap-3 transition-all font-body">
              Openen <ArrowRight size={12} />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default DashboardPage;
